import React, { useEffect, useState } from "react";
import { Button, Input, Form, Select, Checkbox, Switch, Space } from "antd";
import { ShowOTP } from "../ShowOTP/ShowOTP";
import ShowPack from "../ShowPack.js/ShowPack";
import { Link } from "react-router-dom";
import axios from "axios";

const NonHeaderFlow = ({
  formSubmit,
  showPack,
  showOTP,
  OTPSubmit,
  packSubmit,
  isFrench,
  setFrench,
}) => {
  const [number, setNumber] = useState("");
  const [isBoxChecked, setiBoxChecked] = useState(true);
  const [evinaData, setEvinaData] = useState({ tid: '', ti: '', ts: '' });
  const [form] = Form.useForm();

  // ✅ Evina Integration
 useEffect(() => {
   const loadEvinaScript = async () => {
      try {
        const response = await axios.get("/api/get-evina-script");
        console.log("[Evina] Script Loaded", response.data);
        const { s, tid, ti, ts } = response.data;

        const scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        scriptElement.innerHTML = response.data.s;
        document.head.appendChild(scriptElement);
        setEvinaData({ tid, ti, ts });
        const fireEvent = () => {
          const ev = new Event("DCBProtectRun");
          document.dispatchEvent(ev);
          console.log("[Evina] DCBProtectRun dispatched");
        };

        if (document.readyState === "complete" || document.readyState === "interactive") {
          fireEvent();
        } else {
          document.addEventListener("DOMContentLoaded", fireEvent);
        }

      } catch (error) {
        console.error("Failed to load Evina script", error);
      }
    };


  // const loadEvinaScript = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:30621/api/get-evina-script");
  //     console.log("[Evina] Script Loaded", response.data);
  //     const { s, tid, ti, ts } = response.data;

  //     // ✅ Register listener BEFORE dispatch
  //     document.addEventListener("DCBProtectRun", () => {
  //       console.log("[Evina] ✅ DCBProtectRun event received in React");
  //     });

  //     const scriptElement = document.createElement("script");
  //     scriptElement.type = "text/javascript";
  //     scriptElement.innerHTML = s;
  //     document.head.appendChild(scriptElement);

  //     console.log("[Evina] Script appended, dispatching DCBProtectRun");
  //     const ev = new Event("DCBProtectRun");
  //     document.dispatchEvent(ev);

  //     setEvinaData({ tid, ti, ts });

  //   } catch (error) {
  //     console.error("Failed to load Evina script", error);
  //   }
  // };

  loadEvinaScript();
}, []);
  console.log("EVINA SETTED",evinaData)
  return (
    <>
      <Space direction="vertical" style={{ padding: "20px" }}>
        <Switch
          checkedChildren="عربى"
          unCheckedChildren="française"
          defaultChecked
          onChange={(value) => {
            console.log(value);
            setFrench(value);
          }}
        />
      </Space>
      {!showPack && !showOTP ? (
        <Form
          form={form}
          name="form-field"
          initialValues={{ remember: true }}
          onFinish={(values) => isBoxChecked && formSubmit(values)}
          autoComplete="off"
        >
          <Form.Item
            name="msisdn"
            label={`${
              isFrench ? "Numero d'identification" : "إدخال رقم الهاتف المحمول"
            }`}
            rules={[{ required: true }]}
          >
            <Input
              value={number}
              placeholder={`${
                isFrench ? "Entrez un numéro à 12 chiffres 213xxxxxxxxx" : "إدخال رقم الهاتف المحمول"
              }`}
              maxLength="12"
              size="large"
              onChange={(e) => setNumber(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            name="remember"
            valuePropName="checked"
            wrapperCol={{ offset: 8, span: 16 }}
          >
            <Checkbox
              onChange={(e) => setiBoxChecked(e.target.checked)}
              checked={isBoxChecked}
            >
              <Link to="/landing/toonflix/tnc">
                <h5>{isFrench ? "Accepter les termes et conditions" : "قبول الشروط والأحكام"}</h5>
              </Link>
            </Checkbox>
          </Form.Item>

          {!isBoxChecked && (
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <h5 style={{ color: "red" }}>Please accept terms and conditions</h5>
            </Form.Item>
          )}

          <Button
            className="custom-button"
            size="large"
            type="primary"
            htmlType="submit"
          >
            {`${isFrench ? "s'abonner" : "اشترك"}`}
          </Button>
        </Form>
      ) : null}

      {showOTP ? (
        <ShowOTP showOTP={showOTP} OTPSubmit={OTPSubmit} isFrench={isFrench} />
      ) : null}

      {showPack ? (
        <ShowPack
          packSubmit={packSubmit}
          evinaData={evinaData}
          isFrench={isFrench}
          isBoxChecked={isBoxChecked}
        />
      ) : null}
    </>
  );
};

export default NonHeaderFlow;




// import React, { useState } from "react";

// import { Button, Input, Form, Select, Checkbox, Switch, Space } from "antd";
// import { ShowOTP } from "../ShowOTP/ShowOTP";
// import ShowPack from "../ShowPack.js/ShowPack";
// import { Link } from "react-router-dom";
// // import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

// const NonHeaderFlow = ({
//   formSubmit,
//   showPack,
//   showOTP,
//   OTPSubmit,
//   packSubmit,
//   isFrench,
//   setFrench,
// }) => {
//   const [number, setNumber] = useState("");

//   const [isBoxChecked, setiBoxChecked] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const { Option } = Select;
//   const [form] = Form.useForm();
//   //   const onGenderChange = (value) => {
//   //     switch (value) {
//   //       case "daily":
//   //         form.setFieldsValue({
//   //           pack: "Daily",
//   //         });
//   //         return;

//   //       case "weekly":
//   //         form.setFieldsValue({
//   //           pack: "Weekly",
//   //         });
//   //         return;
//   //     }
//   //   };

//   return (
//     <>
//       <Space direction="vertical" style={{ padding: "20px" }}>
//         <Switch
//           checkedChildren="عربى"
//           unCheckedChildren="française"
//           defaultChecked
//           onChange={(value) => {
//             console.log(value);
//             setFrench(value);
//           }}
//         />
//       </Space>
//       {!showPack && !showOTP ? (
//         <Form
//           form={form}
//           name="form-field"
//           initialValues={{
//             remember: true,
//           }}
//           // onFinish={onFinishOTP}
//           onFinish={isBoxChecked && formSubmit}
//           autoComplete="off"
//         >
//           <Form.Item
//             name="msisdn"
//             // label="Input Number"
//             // label=" Numero d'identification"
//             label={`${
//               isFrench ? "Numero d'identification" : "إدخال رقم الهاتف المحمول"
//             }`}
//             rules={[
//               {
//                 required: true,
//               },
//             ]}
//           >
//             <Input
//               // style={{ width: "70%" }}
//               value={number}
//               // placeholder="Entrez un numéro à 12 chiffres 213xxxxxxxxx"
//               placeholder={`${
//                 isFrench
//                   ? "Entrez un numéro à 12 chiffres 213xxxxxxxxx"
//                   : "إدخال رقم الهاتف المحمول"
//               }`}
//               maxLength="12"
//               size="large"
//               // onChange={(e) => setNumber(e.target.value)}
//             />
//           </Form.Item>

//           <Form.Item
//             name="remember"
//             valuePropName="checked"
//             wrapperCol={{
//               offset: 8,
//               span: 16,
//             }}
//           >
//             <Checkbox
//               onChange={(e) => {
//                 setiBoxChecked(e.target.checked);
//                 // console.log(e.target.checked);
//               }}
//             >
//               {" "}
//               <Link to="/landing/toonflix/tnc">
//                 {/* Accepter les termes et conditions */}
//                 <h5>
//                   {isFrench
//                     ? "Accepter les termes et conditions"
//                     : "قبول الشروط والأحكام"}
//                   {/* {`${
//                     isFrench ? (
//                       <h5>Accepter les termes et conditions</h5>
//                     ) : (
//                       "قبول الشروط والأحكام"
//                     )
//                   }`} */}
//                 </h5>
//                 {/* {`${isFrench ?  <h5>Accepter les termes et conditions</h5> : "قبول الشروط والأحكام"}`} */}
//               </Link>
//             </Checkbox>
//           </Form.Item>

//           {!isBoxChecked && (
//             <Form.Item
//               wrapperCol={{
//                 offset: 8,
//                 span: 16,
//               }}
//             >
//               <h5 style={{ color: "red" }}>
//                 Please accept terms and conditions
//               </h5>
//             </Form.Item>
//           )}

//           <Button
//             className="custom-button"
//             size="large"
//             type="primary"
//             htmlType="submit"
//             // onClick={formSubmit}
//             // style={{ textAlign: "center" }}
//           >
//             {/* Subscribe */}

//             {`${isFrench ? "s'abonner" : "اشترك"}`}
//           </Button>
//         </Form>
//       ) : null}

//       {showOTP ? (
//         <ShowOTP showOTP={showOTP} OTPSubmit={OTPSubmit} isFrench={isFrench} />
//       ) : null}
//       {showPack ? (
//         <ShowPack
//           packSubmit={packSubmit}
//           isFrench={isFrench}
//           isBoxChecked={isBoxChecked}
//         />
//       ) : null}
//     </>
//   );
// };

// export default NonHeaderFlow;
